import { render, staticRenderFns } from "./Upscope.vue?vue&type=template&id=3be0b9ce&scoped=true&"
import script from "./Upscope.vue?vue&type=script&lang=ts&"
export * from "./Upscope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0b9ce",
  null
  
)

export default component.exports